// traversal — the walked path as drawable segments.
//
// Moment topologies declare no forward edges (only branch `return` edges), so
// the run's movement cannot be read from `topology.connections`. The movement
// is the walked path itself: each consecutive pair of actualPath nodes is one
// hop. The last hop is the "current" one — where the payload is travelling.
// Pure: no React, no Redux.

import type { NodePosition } from './layoutEngine.ts';

export interface TraversalSegment {
  /** Position key within the walk (stable, handles revisits). */
  key: string;
  /** Scenario-namespace node ids, as walked. */
  from: string;
  to: string;
  fromPos: NodePosition;
  toPos: NodePosition;
  /** The most recent hop — the payload is on it. */
  isCurrent: boolean;
}

export function deriveTraversal(
  actualPath: string[],
  resolveId: (scenarioNodeId: string) => string,
  nodePositions: Record<string, NodePosition>,
): TraversalSegment[] {
  const segments: TraversalSegment[] = [];
  for (let i = 1; i < actualPath.length; i++) {
    const from = actualPath[i - 1];
    const to = actualPath[i];
    const fromPos = nodePositions[resolveId(from)] ?? nodePositions[from];
    const toPos = nodePositions[resolveId(to)] ?? nodePositions[to];
    if (!fromPos || !toPos) continue;
    segments.push({ key: `${i}:${from}->${to}`, from, to, fromPos, toPos, isCurrent: false });
  }
  if (segments.length > 0 && actualPath.length > 1) {
    const last = segments[segments.length - 1];
    // Only current if it is truly the final hop (not an unresolved tail).
    if (last.key.startsWith(`${actualPath.length - 1}:`)) last.isCurrent = true;
  }
  return segments;
}
